import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "ui-dialog-base",
    templateUrl: "./dialog-base.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class DialogBaseComponent implements OnInit {
    @Input()
    allowCancelTouchingOutside: boolean = true;

    @Input()
    showCloseButton: boolean = true;

    @Input()
    classes: string[] = ["sm:w-60vw"];

    @Input()
    title: string;

    constructor(public matDialogRef: MatDialogRef<DialogBaseComponent>) {
        this.matDialogRef.addPanelClass(["xs-full-screen"]);
    }

    ngOnInit(): void {
        this.matDialogRef.disableClose = !this.allowCancelTouchingOutside;
    }

    close() {
        this.matDialogRef.close();
    }
}
